<template>
  <v-dialog :value="true" persistent :max-width="600">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        <span>Reordenar {{documentoReordenar.nome.substring(0, 40)}}
          <v-tooltip top v-if="documentoReordenar.nome.length >= 40">
            <span slot="activator">...</span>
            {{documentoReordenar.nome}}
          </v-tooltip>
        </span>
        <v-spacer/>
        <v-icon @click="fecharModal" color="white">close</v-icon>
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div class="az-text mb-3">
          <p><strong>Selecione o documento para trocar a posição</strong></p>
          <v-select placeholder="Selecione uma posição"
                    :items="elementosSelect"
                    v-model="sequencialSelecionado"
                    item-text="texto"
                    item-value="numeroSequencial"
                    align="center"
          />
        </div>
      </v-card-text>
      <v-card-actions class="acoes justify-center">
        <v-btn id="botao-cancelar-reordenar" class="mx-2" color="#777" flat @click="fecharModal">
          Cancelar
        </v-btn>
        <v-spacer/>
        <v-btn id="botao-confirmar-reordenar" class="botao-acao mx-2" flat @click="confirmar">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalReordenarDocumento',
  props: ['documentoReordenar','documentosJuntados'],
  data(){
    return{
      sequencialSelecionado: null
    }
  },
  computed:{
    elementosSelect(){
      if(!this.documentosJuntados) {
        return;
      }

      const ordenacaoPorPagina = (a, b) => {
        return parseInt(a.primeiraPagina) < parseInt(b.primeiraPagina) ? -1 : 1
      }

      return this.documentosJuntados
          .filter(doc => doc.documentoVirtualizadoId !== this.documentoReordenar.documentoVirtualizadoId)
          .sort(ordenacaoPorPagina)
          .map(doc => {
            const texto =  `${doc.nome} - Pg. de ${doc.primeiraPagina} até ${doc.ultimaPagina}`
            return {
              numeroSequencial: doc.numeroSequencial,
              texto: texto
            }
      })
    }
  },
  methods: {
    confirmar(){
      this.$emit('confirmar', this.sequencialSelecionado)
    },
    fecharModal() {
      this.$emit('fechar')
    },
  }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 600

.botao-acao
  border 1px solid #0067a5
  background-color #0067a5 !important
  color #fff !important
  box-sizing border-box

.acoes
  padding-top 20px !important
  padding-bottom 10px !important
</style>